import { useEffect, useState } from 'react';
import { ContractBranch } from '../../../../models/Entities/Contracts/ContractBranch';

// component functions 
import * as ComponentFunctions from './BranchList.Functions';

//styles
import './BranchList.Styles.css';
import { Button, Label, Spinner } from '@fluentui/react-components';
import { Add24Regular } from '@fluentui/react-icons';
import { ErrorMessageComponent } from '../../../Error/ErrorMessageComponent';
import { BranchItemComponent } from './BranchItem.Component';
import { connect } from 'react-redux';
import BranchFormComponent from '../BranchForm/BranchForm.Component';

////i18Next
import { useTranslation } from 'react-i18next';

export const BranchListComponent = (props: ComponentFunctions.Props) => {
    // initial values
    const [isOpenInitialSettings, setIsOpenInitialSettings] = useState<boolean>(false);
    const [selectedBranch, setSelectedBranch] = useState<ContractBranch | undefined>(undefined);

    // If ContractAddendumId is provided, use GetContractBranchsByAddendumId instead
    useEffect(() => {
        if (props.Contract && props.ContractAddendumId) {
            props.GetContractBranchsByAddendumId(props.ContractId, props.ContractAddendumId);
        } else if (props.Contract && !props.ContractAddendumId) {
            props.GetAllContractsBranchs(props.ContractId);
        }
    }, [props.Contract === undefined, props.ContractAddendumId]);

    // Add or eddit visit
    const [isOpenVisit, setIsOpenVisit] = useState<boolean>(false);

    const handleInitialSettingsClosePanel = () => {
        setIsOpenInitialSettings(false);
    };

    const handleVisitClosePanel = () => {
        setSelectedBranch(undefined);
        setIsOpenVisit(false);
    };

    const handleChargeVisitInformation = () => {
        setIsOpenInitialSettings(true);
    };

    const HandleAddEvent = () => {
        setIsOpenVisit(true);
    };

    const HandleEditEvent = (Branch: ContractBranch) => {
        setSelectedBranch(Branch);
        setIsOpenVisit(true);
    }

    const HandleDeleteEvent = (branch: ContractBranch) => {
        props.DeleteContractBranch(branch.id, props.ContractId);
    }

    //useTranslation()
    const [t] = useTranslation();

    // Loading
    const Loading = (props.isLoading || props.isUpdating) && (
        <div>
          <Spinner
            label={t('branchList.loading.carryingBranches')}
            labelPosition="below"
          />
        </div>
    );

    const ComponentActions = (
        <>
            <Button
                appearance="primary"
                onClick={HandleAddEvent}
                icon={<Add24Regular />}
                className="actionButton"
            >
                {t('branchList.componentActions.addBranch')}
            </Button>
        </>
    )

    const ErrorMessage = (props.failOnLoading || props.failOnUpdating) && props.error && (
            <ErrorMessageComponent Error={props.error} />
        )

    const NoRegistries = (props.isLoadingSuccessfully || props.isUpdatedSuccessfully) && (props.branches?.length === 0 || props.branches?.length === undefined) && (
        <div className="NoDataSection">
            <img
                src={require('../../../../assets/img/empty_state.gif')}
                alt="Ichtys"
                className="bl-empty-illustration"
            ></img>
            <Label className="bl-empty-title">{t('branchList.noRegistries.registeredBranches')}</Label>
        </div>
    );

    const Forms = <>
        {props.ContractAddendumId && <BranchFormComponent 
            isOpen={isOpenVisit}
            dismissPanel={handleVisitClosePanel}
            ContractId={props.ContractId}
            ContractAddendumId={props.ContractAddendumId}
            ContractBranchId={selectedBranch?.id}    
        />}
    </>


    return (
        <div className="bl-shell">
            <div className="bl-toolbar">
                {ComponentActions}
            </div>
            {ErrorMessage}
            {props.isLoading ? <div className="bl-loading">{Loading}</div> : null}
            <div className="bl-list">
            {props.branches?.map((Branch, index) => (
                <BranchItemComponent 
                    key={Branch.id}
                    Branch={Branch} index={index} 
                    onEdit={(Branch: ContractBranch) => HandleEditEvent(Branch)}
                    onDelete={(Branch: ContractBranch) => HandleDeleteEvent(Branch)}
                    deleteProcess={props.isDeleting}
                    deleteSuccess={props.isDeletedSuccessfully}
                    deleteError={props.failOnDeleting}
                    Error={props.error}
                    Protocols={props.Protocols}
                />
            ))}
            </div>
            {NoRegistries}
            {Forms}
        </div>
    )
}

export default connect(
    ComponentFunctions.mapStateToProps,
    ComponentFunctions.mapDispatchToProps
  )(BranchListComponent as any);
